import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FacebookIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.506 6.617V8.006H17.5L17.124 11.999H13.498V22H9.51V11.999H6.5V8.006H9.51V6.198C9.51 4.558 10.102 2 13.649 2L17.5 2.012V5.655H14.42C14.042 5.655 13.506 5.838 13.506 6.617Z",
    fill: "currentColor"
  }));
}